import { toast } from "react-toastify";
import { DropdownActions, DropdownItem } from "../../commons/DropdownActions";
import type { Post } from "../../../services/webServices/post/types";
import { patchPost } from "../../../services/webServices/post/patch";

type Props = {
  post: Post;
  onActionSuccessed: () => void;
};

export default function PostAction({ post, onActionSuccessed }: Props) {

  const updatePostStatus = async (status: boolean): Promise<boolean> => {
    if (post.is_published === status) {
      toast.info("وضعیت همین الان هم همین است");
      return false;
    }

    try {
      const success = await patchPost({
        id: post.id,
        body: { is_published: status }
      });

      if (!success) return false;

      toast.success("تغییر وضعیت با موفقیت انجام شد");
      onActionSuccessed();
      return true;

    } catch {
      return false;
    }
  };

  const actions: DropdownItem[] = [
    {
      key: "published",
      tone: "success",
      label: "انتشار",
      action: () => updatePostStatus(true),
    },
    {
      key: "draft",
      tone: "warning",
      label: "پیش نویس",
      action: () => updatePostStatus(false),
    },
  ];

  return (
    <DropdownActions
      items={actions}
      initialKey={post.is_published ? "published" : "draft"}
    />
  );
}